module.exports = __webpack_public_path__ + "static/media/189.77d9f443.jpg";